<style>
.hid {
    display: hidden;
}
.v-dialog > .v-overlay__content > .v-card, .v-dialog > .v-overlay__content > form > .v-card {
    border-radius: 0px;

}
.v-dialog > .v-overlay__content > .v-card > .v-card-item, .v-dialog > .v-overlay__content > form > .v-card > .v-card-item {
    padding: 14px 24px !important;
}
.nor {
    border-radius: 0px !important;
}
</style>
<template>
    <div class="d-flex ">
        <!-- <h1>Speed test</h1> -->
        <!-- <div v-for="it in items">{{ it }}</div> -->
        <button :class="'btn btn-lg btn-default btn-primary ml-2' + btnConnectCls" @click="connect">{{connectBtn}}</button>
        
        <v-dialog v-model="showDlg" header="Header" persistent width="600">
            <!-- Dialog infomation -->
            <v-card :title="title" class="nor"></v-card>
            
            
            <v-card v-if="!connectStatus" class="p-3 nor">
                
                
                    
                    <div v-if="errMsg!=''" class="p-3 mb-2 bg-danger text-white">{{errMsg}}</div>
                    <div class="m-3 d-flex flex-raw justify-content-center">
                        <button  class="btn btn-lg btn-default btn-primary" @click="changeBot">{{$t("message.change-leanbot")}}</button>
                        <button  class="ms-3 btn btn-lg btn-default btn-primary" @click="reconnect">{{$t("message.reconnect")}}</button>
                    </div>
                   

            </v-card>
          
            
            <v-card class="pb-4 pt-4 nor" v-if="connectStatus">
                <div class="d-flex flex-column justify-content-center align-items-center">
                    
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <div class="mt-2">Please stand by</div>
                      
                </div>
            </v-card>
        
        </v-dialog>
        

        <v-dialog v-model="showEmulatorDlg" header="Header" persistent width="600">
            <!-- Dialog infomation -->
            <v-card :title="'Emulator leanbot'" class="nor"></v-card>
            
            
           
          
            
            <v-card class="pb-4 pt-4 nor">
                <div class="d-flex flex-column justify-content-center align-items-center">
                   <textarea v-model="code" class="form-control" rows="3"></textarea>
                </div>
            </v-card>
        
        </v-dialog>
    </div>
</template>

<script src="@/views/bot-manager/speed.ts"></script>
